import Phaser from "phaser";
export default class StartGame extends Phaser.Scene
{
    constructor()
    {
        super('start-scene')
    }

    init()
    {

    }

    preload()
    {
        this.load.image('start-btn', 'images/start_pink.png')
        this.load.image('startBackground','images/startbackground.jpg')
        this.load.image('logo','images/Logomariocrop.png')
        this.load.image('thetitle','images/thetitle.png')
        this.load.image('created','images/createdby.png')
        this.load.image('insDown','images/keydown.png')
        this.load.image('insUp','images/keyup.png')
        this.load.image('insRight','images/keyright.png')
        this.load.image('insLeft','images/keyleft.png')
        this.load.image('insSpace','images/keyspace.png')        
        this.load.image('GameItemsTitle','images/GameItemsTitle.png')
        this.load.image('GameGold','images/GameGoldButton.png')
        this.load.image('GameSilver','images/GameSilverButton.png')
        this.load.image('GameKunai','images/GameKunai.png')
    }

    create()
    {
        this.add.image(960,540, 'startBackground')
        this.add.image(960,870,'logo').setAlpha(2)
        this.startButton = this.add.image(960,540,'start-btn').setInteractive().setOrigin(0.5,0.5).setScale(0.5)
        
        this.startButton.once('pointerup', ()=> {this.scene.start('individual-game')},this)

        //this.add.text(500,400,'QUICK TIPS').setOrigin(0.5)

        //this.add.text(960,400,'THE NINJA LIGHT', {fontFamily:'fantasy', font:'30px',fontStyle:'bold',color:'#08B9F2'}).setOrigin(0.5,0.5).setScale(2)
        
        this.add.image(960,300,'thetitle').setScale(0.5)
        //this.add.image(960,800,'created').setScale(0.25)
        
        this.add.image(350,300,'insUp').setScale(0.25)
        this.add.image(350,450,'insDown').setScale(0.25)
        this.add.image(350,600,'insRight').setScale(0.25)
        this.add.image(350,750,'insLeft').setScale(0.25)
        this.add.image(350,900,'insSpace').setScale(0.25)

        this.add.image(1570,300,'GameItemsTitle').setScale(0.5) 
        this.add.image(1570,475, 'GameGold').setScale(0.25)
        this.add.image(1570,650, 'GameSilver').setScale(0.25)
        this.add.image(1570,825, 'GameKunai').setScale(0.25)
    }

}